import {
  deleteOutlet,
  getAllOutlets,
  getOutlet,
  newOutlet,
  updateOutlet,
  updateOutletCoordinate,
} from '../outlet-service';

export default {
  /**
   * Get All outlets
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchAllOutlets({ commit }) {
    const response = await getAllOutlets();
    commit('setProperty', { property: 'pagination', payload: response.pagination });
    commit('setProperty', { property: 'outlets', payload: response.data ? response.data : response });
  },

  /**
   *
   * @param context
   * @param outlet
   * @returns {Promise<void>}
   */
  async getOutlet({ commit }, { outletId }) {
    const response = await getOutlet(outletId);
    commit('setProperty', { property: 'outlet', payload: response });
  },

  /**
   *
   * @param commit
   * @param outletId
   * @returns {Promise<void>}
   */
  async deleteOutlet({ commit }, { outletId }) {
    await deleteOutlet(outletId);
    commit('delProperty', { property: outletId });
  },

  /**
   *
   * @param context
   * @param outletId
   * @param outlet
   * @returns {Promise<void>}
   */
  async updateOutlet(context, { outletId, outlet }) {
    await updateOutlet(outletId, outlet);
  },

  /**
   *
   * @param context
   * @param outlet
   * @returns {Promise<void>}
   */
  async newOutlet({ commit }, { outlet }) {
    const response = await newOutlet(outlet);
    commit('setNewOutlet', { payload: response });
    commit('setProperty', { property: 'outlet', payload: response });
  },

  /**
   *
   * @param context
   * @param outlet
   * @returns {Promise<void>}
   */
  async getOutletCoordinate({ commit }, { address }) {
    const response = await updateOutletCoordinate(address);
    commit('setProperty', { property: 'outlet', payload: response });
  },
};
